/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getFunds = /* GraphQL */ `
  query GetFunds {
    getFunds {
      citicode
      name
      amc
      inceptionDate
    }
  }
`;
export const getPortfolioData = /* GraphQL */ `
  query GetPortfolioData($input: PortfolioDataInput!) {
    getPortfolioData(input: $input) {
      seriesData {
        date
        value
      }
    }
  }
`;
